import script from "./MyFilter.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyFilter.vue?vue&type=script&lang=ts&setup=true"

import "./MyFilter.vue?vue&type=style&index=0&id=0c50230e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c50230e"]])

export default __exports__